import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Logo from './Logo';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const links = [
    { href: '/#features', label: 'Features' },
    { href: '/#how', label: 'How it works' },
    { href: '/#vendors', label: 'For Vendors' },
    { href: '/#pricing', label: 'Pricing' },
  ];

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50,
      background: 'rgba(250,251,250,0.96)',
      backdropFilter: 'blur(16px)',
      borderBottom: '1px solid #E8EBE8',
      height: 64,
    }}>
      <div style={{ maxWidth: 1152, margin: '0 auto', padding: '0 24px', height: '100%', display: 'flex', alignItems: 'center', gap: 12 }}>

        <Link to="/" style={{ textDecoration: 'none' }}>
          <Logo size={36} showText={true} textBelow={false} />
        </Link>

        <div style={{ flex: 1 }} />

        {/* Desktop links */}
        <div className="nav-desktop" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {links.map(l => l.href ? (
            <a key={l.href} href={l.href} style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 13, color: '#4A5248', textDecoration: 'none', padding: '7px 14px', borderRadius: 7, transition: 'all 0.14s' }}
              onMouseOver={e => { e.currentTarget.style.background = 'rgba(133,187,101,0.1)'; e.currentTarget.style.color = '#3d6b27'; }}
              onMouseOut={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#4A5248'; }}>
              {l.label}
            </a>
          ) : (
            <Link key={l.to} to={l.to} style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 13, color: '#4A5248', textDecoration: 'none', padding: '7px 14px', borderRadius: 7, transition: 'all 0.14s' }}
              onMouseOver={e => { e.currentTarget.style.background = 'rgba(133,187,101,0.1)'; e.currentTarget.style.color = '#3d6b27'; }}
              onMouseOut={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#4A5248'; }}>
              {l.label}
            </Link>
          ))}

          <a href={`${process.env.REACT_APP_APP_URL || 'http://localhost:3000'}/customer.html`} style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 700, fontSize: 13, color: '#fff', textDecoration: 'none', padding: '8px 18px', borderRadius: 8, background: '#85BB65', boxShadow: '0 2px 10px rgba(133,187,101,0.25)', transition: 'background 0.14s', marginLeft: 4 }}
            onMouseOver={e => e.currentTarget.style.background = '#5E9444'}
            onMouseOut={e => e.currentTarget.style.background = '#85BB65'}>
            Get Started
          </a>
        </div>

        {/* Hamburger — shown on mobile via CSS */}
        <button onClick={() => setOpen(!open)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8, display: 'none', flexDirection: 'column', gap: 5 }}
          className="nav-hamburger">
          {[0, 1, 2].map(i => (
            <span key={i} style={{
              display: 'block', width: 20, height: 1.5, background: '#4A5248', borderRadius: 2, transition: 'all 0.2s',
              transform: open ? (i === 0 ? 'rotate(45deg) translate(4px, 4px)' : i === 2 ? 'rotate(-45deg) translate(4px, -4px)' : 'scaleX(0)') : 'none',
              opacity: open && i === 1 ? 0 : 1,
            }} />
          ))}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }}
            style={{ borderTop: '1px solid #E8EBE8', overflow: 'hidden', background: '#FAFBFA' }}>
            <div style={{ padding: '12px 24px 16px', display: 'flex', flexDirection: 'column', gap: 4 }}>
              {links.map(l => l.href ? (
                <a key={l.href} href={l.href} onClick={() => setOpen(false)} style={{ padding: '10px 14px', borderRadius: 8, textDecoration: 'none', fontFamily: "'Raleway', sans-serif", fontWeight: 500, fontSize: 14, color: '#4A5248' }}>
                  {l.label}
                </a>
              ) : (
                <Link key={l.to} to={l.to} onClick={() => setOpen(false)} style={{ padding: '10px 14px', borderRadius: 8, textDecoration: 'none', fontFamily: "'Raleway', sans-serif", fontWeight: 500, fontSize: 14, color: '#4A5248', background: location.pathname === l.to ? 'rgba(133,187,101,0.08)' : 'transparent' }}>
                  {l.label}
                </Link>
              ))}
              <a href={`${process.env.REACT_APP_APP_URL || 'http://localhost:3000'}/customer.html`} onClick={() => setOpen(false)} style={{ padding: '10px 14px', borderRadius: 8, textDecoration: 'none', fontFamily: "'Raleway', sans-serif", fontWeight: 700, fontSize: 14, color: '#5E9444' }}>
                Get Started
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`@media(max-width:640px){ .nav-hamburger{ display:flex !important; } .nav-desktop{ display:none !important; } }`}</style>
    </nav>
  );
}
